module.exports = __webpack_public_path__ + "img/text-to-video.8d1c7efa.svg";